import { render } from "./ProductManageIcon.vue?vue&type=template&id=e3f20166"
import script from "./ProductManageIcon.vue?vue&type=script&lang=js"
export * from "./ProductManageIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ProductManageIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e3f20166"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e3f20166', __exports__)) {
    api.reload('e3f20166', __exports__)
  }
  
  module.hot.accept("./ProductManageIcon.vue?vue&type=template&id=e3f20166", () => {
    api.rerender('e3f20166', render)
  })

}


export default __exports__